module.exports = __webpack_public_path__ + "img/saddle-cloths-1.37f607ab.svg";